import request from "@/utils/request.js";

/**
 * 用户卡券兑换课程
 * @param params
 * @returns {AxiosPromise}
 */
export function exchangeUserCoupon(params) {
  return request({
    url: "/userService/api/user/coupon/exchangeUserCoupon",
    method: "post",
    data: params
  });
}

/**
 * 兑换课程详情
 * @param params
 * @returns {AxiosPromise}
 */
export function getUserCouponDetails(params) {
  return request({
    url: "/userService/api/user/coupon/getUserCouponDetails",
    method: "post",
    data: params
  });
}
